var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.941,
    height: 10.997,
    viewBox: "0 0 8.941 10.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.505 11h7.33a.808.808 0 0 0 .805-.805V5.811a.808.808 0 0 0-.805-.805h-.567V3.1a3.1 3.1 0 1 0-6.2 0v1.906h-.567a.808.808 0 0 0-.805.805v4.381a.808.808 0 0 0 .809.808zm1.118-7.9a2.547 2.547 0 0 1 5.094 0v1.906h-5.093zm-1.372 2.711a.255.255 0 0 1 .254-.254h7.33a.255.255 0 0 1 .254.254v4.381a.255.255 0 0 1-.254.254h-7.33a.255.255 0 0 1-.254-.254z",
    transform: "translate(-45.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.623 307.945a1.123 1.123 0 1 0-1.123-1.123 1.124 1.124 0 0 0 1.123 1.123zm0-1.692a.571.571 0 1 1-.571.572.572.572 0 0 1 .571-.572z",
    transform: "translate(-191.152 -298.822)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.2e154b38394e6dfa3baa5045cdb922da.svg";
export { ForwardRef as ReactComponent };